import { render, staticRenderFns } from "./disputa.vue?vue&type=template&id=2c372018&"
import script from "./disputa.vue?vue&type=script&lang=js&"
export * from "./disputa.vue?vue&type=script&lang=js&"
import style0 from "./disputa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports